<script>
import TwTransitionListContainer from '@/components/generic/tw-transition-list-container.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import TwCard from '@/components/generic/tw-card.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
import TwButton from '@/components/generic/tw-button.vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

export default {
  name: 'TwCardWithBackdrop',
  components: { TwButton, TwCard, TwContainer, XMarkIcon },
  props: {
    backdropUrl: {
      type: String,
      required: false,
      default:null
    },
    showCloseButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['close']
}
</script>

<template>
  <div class="min-h-screen bg-cover bg-no-repeat" :style="`background-image: url('${backdropUrl}');`">
    <div class="bg-black/65">
      <div class="z-10 flex justify-center md:p-6">
        <tw-card class="bg-white rounded-none md:rounded-xl w-full sm:max-w-lg relative">
          <tw-button v-if="showCloseButton" variant="link" class="absolute right-4 top-4" @click="$emit('close')">
            <XMarkIcon class="size-7" />
          </tw-button>
          <slot />
        </tw-card>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
